<template>
  <list :list="data"
        empty-string="暂无系列"
        :show-empty="showEmpty"
  />
</template>

<script>
  import List from '@/components/ProductList/List';

  export default {
    name: 'ComboList',
    components: {
      List,
    },
    data() {
      return {
        data: [],
      };
    },
    props: {
      list: {
        type: Array,
        required: true,
        default() {
          return [];
        },
      },
      showEmpty: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      list(val) {
        this.data = this.generateData(val);
      },
    },
    methods: {
      generateData(data) {
        data.forEach((item) => {
          item.productType = 'combo';
          return item;
        });
        return data;
      },
    },
    created() {
      this.data = this.generateData(this.list);
    },
  };
</script>
